/* eslint import/prefer-default-export: 0 */
// TODO: fix newly added financial sections so that they have the standard locale format as opposed to the ifYes, ifNo stuff

export const financial = {
  pvq: {
    shared: {
      estimated: 'Estimated',
      none: 'None',
      noneOther: 'None/Other',
      idk: 'I don\'t know',
      na: 'Not Applicable',
    },
    subsection: {
      intro: 'Financial intro',
      gambling: 'Gambling',
      bankruptcy: 'Bankruptcy',
      taxes: 'Taxes',
      card: 'Employer card abuse',
      credit: 'Credit counseling',
      delinquent: 'Delinquent payments',
      nonpayment: 'Non-payment consequence',
      alimony: 'Alimony',
      childsupport: 'Child support',
      civiljudgement: 'Civil judgement',
      lien: 'Lien',
      foreclosure: 'Foreclosure',
      repossession: 'Repossession',
      federalDebt: 'Federal debt',
      eviction: 'Eviction',
      nonpaymentnonfederal: 'Nonpayment nonfederal',
      assetseized: 'Asset seized',
      review: 'Review Financial record',
    },
    destination: {
      federalDebt: 'Section 15: Federal Debt',
      para: 'This section asks for information regarding any federal financial debt you have, including federal tax debt and any federal non-tax debt.  Examples of federal non-tax debt include past due federally guaranteed or insured loans such as student and home mortgage loans, overpayment of benefits, or other debts to the U.S. Government. This section also focuses on the actions you have taken to address past due financial obligations, as applicable.',
      paraSecond:
      'For this section:\n• Past due:\n -- Means a payment was not made by its due date or by the end of the grace period, if applicable.\n -- For other debts paid in installments, such as loans, "past due" means a payment was not made by its due date or by the end of the grace period, if applicable.\n -- You are not "past due" if you were approved for a tax extension and you filed and paid your taxes by the extension due date.\n• A tax year is the 12 months covered by a tax return. \n• A guarantor is an individual who promises to pay a borrowers debt in the event the borrower defaults on their loan obligation ',
      intro: 'Financial intro',
      gambling: 'Gambling',
      bankruptcy: 'Bankruptcy',
      taxes: 'Taxes',
      card: 'Employer card abuse',
      credit: 'Credit counseling',
      delinquent: 'Delinquent payments',
      nonpayment: 'Non-payment consequence',
      alimony: 'Alimony',
      childsupport: 'Child support',
      civiljudgement: 'Civil judgement',
      lien: 'Lien',
      foreclosure: 'Foreclosure',
      repossession: 'Repossession',
      eviction: 'Eviction',
      nonpaymentnonfederal: 'Nonpayment nonfederal',
      assetseized: 'Asset seized',
      review: 'Review Financial record',
    },
    federalDebt: {
      yesLabel: 'Yes',
      noLabel: 'No',
      idkLabel: 'I Don\'t Know',
      failedToFile: {
        title: 'Are there any tax year(s) within the past five years for which you have '
        + 'failed to file a federal tax return? Answer "No" if 1) you were not required '
        + 'to file because you did not earn enough money or 2) you were not required by '
        + 'law to file Federal income taxes.',
        summary: 'Summary of failed tax filings',
        item: 'Agency',
        placeholder: 'Provide your tax filing information',
        year: 'What tax year did you fail to file? (Input one tax year at a time. There '
        + 'will be an opportunity to input multiple entries.)',
        reason: 'Why did you not file these taxes?',
        intent: {
          question: 'Do you intend to file these taxes?',
          ifYes: 'When do you intend to file these taxes?',
          ifNo: 'Why?',
        },
        append: {
          title: 'Do you have another instance in which you failed to file your federal '
          + 'taxes in the past five years? Answer "No" if 1) you were not required to '
          + 'file because you did not earn enough money or 2) you were not required by '
          + 'law to file federal income taxes.',
          add: 'Add another tax filing issue',
        },
        collection: {
          summary: {
            title: 'Summary of financial problems',
            unknown: 'Provide your financial problem details',
            item: 'Issue',
          },
        },
      },
      failedToPay: {
        title: 'Have you failed to pay the amount due on your federal taxes for any tax '
        + 'year(s) in the past five years? Answer "No" if you 1) were not required to '
        + 'file or pay because you did not earn enough money, 2) did not owe the IRS '
        + 'money (you received or were entitled to a refund), or 3) were not required by '
        + 'law to file or pay federal income taxes.',
        summary: 'Summary of failed tax payments',
        item: 'Agency',
        placeholder: 'Provide your tax payment information',
        year: 'For what tax year have you failed to pay the amount due? (Input one tax '
        + 'year at a time. There will be an opportunity to input multiple entries.)',
        amount: 'How much do you owe in U.S. dollars?',
        actionsTaken: {
          question: 'What actions have you taken to pay these taxes? (Select all that '
          + 'apply.)',
          ifNoneOrOther: 'Please explain.',
        },
        append: {
          title: 'Are there other tax year(s) in the past five years for which you have '
          + 'you failed to pay the amount due on your federal taxes? Answer "No" if you '
          + '1) were not required to file or pay because you did not earn enough money, '
          + '2) did not owe the IRS money (you received or were entitled to a refund), '
          + 'or 3) were not required by law to file or pay federal income taxes.',
          add: 'Add another tax payment issue',
        },
        collection: {
          summary: {
            title: 'Summary of financial problems',
            unknown: 'Provide your financial problem details',
            item: 'Issue',
          },
        },
      },
      otherPastDue: {
        title: 'Are you currently past due on any federal non-tax debt? (This includes '
        + 'past due federally guaranteed or insured loans such as student and home '
        + 'mortgage loans, overpayment of benefits, and other debts to the U.S. '
        + 'Government. List if you are the sole debtor, a cosigner, or a guarantor.)',
        summary: 'Summary of other past due accounts',
        item: 'Agency',
        placeholder: 'Provide your other federal debt information',
        agency: 'What is the name of the government agency or organization you owe? (Do '
        + 'not use acronyms or abbreviations in the name.)',
        debtType: {
          question: 'What type of federal non-tax debt are you past due on? (Check one. '
          + 'There will be an opportunity to input multiple entries.)',
          ifOther: 'Please explain.',
        },
        accountNum: 'What is the loan or account number associated with this debt?',
        propertyType: 'What type of property is involved?',
        amount: 'How much are you past due (in U.S. dollars)?',
        why: 'Why are you past due on this debt?',
        when: 'When did you become past due on this debt?',
        legalState: {
          question: 'Have you had a judgment entered against you or a lien placed '
          + 'against your property as a result of this debt?',
          ifYes: {
            question: 'Which did you receive?',
            judgement: 'Judgement',
            lien: 'Lien',
            courtName: 'What is the name of the court or government office where '
            + 'this judgment or lien is recorded? (Do not use acronyms or abbreviations '
            + 'in the name.)',
            courtAddress: 'What is the address of this court or government office?',
            amount: 'What is the amount of the judgment or lien (in U.S. dollars)?'
          },
        },
        actionsTaken: {
          question: 'What actions have you taken to resolve this debt? (Select all that apply.)',
          ifNoneOrOther: 'Please explain.',
        },
        append: {
          title: 'Do you have another instance in which you are currently past due on '
          + 'federal non-tax debt? (This includes past due federally guaranteed or '
          + 'insured loans such as student and home mortgage loans, overpayment of '
          + 'benefits, and other debts to the U.S. Government. List if you are the sole '
          + 'debtor, a cosigner, or a guarantor.)',
          add: 'Add another federal debt past due issue',
        },
        collection: {
          summary: {
            title: 'Summary of financial problems',
            unknown: 'Provide your financial problem details',
            item: 'Issue',
          },
        },
      },
    },
    bankruptcy: {
      branch: {
        title: 'Have you filed for bankruptcy in the past five years?',
        ifYes: {
          chapterRadio: 'Which chapter of the U.S. Bankruptcy Code did you file under?',
          branchIdk: {
            title: 'Was the bankruptcy filed jointly with another individual?',
          },
          nameText: 'Name of Individual',
          accountNumTextIdk: 'What is the court docket or account number for this bankruptcy?',
          courtNameText: 'What is the name of the bankruptcy court that handled this bankruptcy? (Do not use acronyms or abbreviations.)',
          courtLocation: 'Where is this bankruptcy court located?',
          whenFiled: 'When did you file your bankruptcy paperwork with the bankruptcy court?',
          amountCurrency: 'How much money was involved in this bankruptcy (in U.S. dollars)?',
          usedName: 'What name did you use to file this bankruptcy?',
          adminName: 'What is the name of the bankruptcy administrator or trustee for this bankruptcy?',
          adminLocation: 'What is their address?',
          branch: {
            title: 'Was this bankruptcy discharged? (This means you were released from any obligation to repay the debts claimed in your bankruptcy.)',
            ifYes: {
              whenDateEstimated: 'When was this bankruptcy discharged? (This is the date of the court order ending your bankruptcy proceeding.)',
            },
            ifNo: {
              explainTextArea: 'Please explain.',
            },
          },
        },
        appendTitle: 'Do you have another instance where you filed for bankruptcy in the past five years?',
      },
    },
    alimony: {
      collection: {
        summary: {
          item: 'Alimony',
          unknown: 'Provide your alimony details below',
        },
      },
      branch: {
        title: 'In the past five years, have you been over 120 days past due on any alimony payments?',
        ifYes: {
          recipientName: 'Who do or did you owe alimony to?',
          amountRequiredToPayCurrency: 'How much are or were you required to pay in alimony monthly (in U.S. dollars)?',
          amountPastDueCurrency: 'How much are or were you past due (in U.S. dollars)?',
          whyTextArea: 'Why are or were you past due?',
          whenDateEstimated: 'When did you become past due?',
          branch: {
            title: 'Are you currently over 120 days past due?',
            ifNo: {
              whenDateEstimated: 'When did you become current, or less than 120 days past due, on your alimony payments? ',
            },
            ifYes: {
              combobox: {
                actionsTaken: 'What actions have you taken to become current on these alimony payments?',
                ifNoneTextArea: 'Please explain.',
              },
            },
          },
          courtNameText: 'What is the name of the court involved? (Do not use acronyms or abbreviations.)',
          courtLocation: 'What is this court\'s address?',
          orderNumTextIdk: 'What is the court docket or order number for these alimony payments?',
        },
      },
      appendTitle: 'Do you have another instance where you are or were over 120 days past due on alimony payments in the past five years?',
    },
    childSupport: {
      collection: {
        summary: {
          item: 'Child Support',
          unknown: 'Provide your child support details below',
        },
      },
      branch: {
        title: 'Have you been over 120 days past due on any child support payments in the past five years?',
        ifYes: {
          recipientName: 'Who do or did you owe child support to?',
          amountRequiredToPayCurrency: 'How much are or were you required to pay in child support monthly (in U.S. dollars)?',
          amountPastDueCurrency: 'How much are or were you past due (in U.S. dollars)?',
          whyTextArea: 'Why are or were you past due?',
          whenDateEstimated: 'When did you become past due?',
          branch: {
            title: 'Are you currently over 120 days past due?',
            ifNo: {
              whenDateEstimated: 'When did you become current, or less than 120 days past due, on your child support payments?',
            },
            ifYes: {
              combobox: {
                actionsTaken: 'What actions have you taken to become current on these child support payments?',
                ifNoneTextArea: 'Please explain.',
              },
            },
          },
          courtNameText: 'What is the name of the court involved? (Do not use acronyms or abbreviations.)',
          courtLocation: 'What is this court\'s address?',
          orderNumTextIdk: 'What is the court docket or order number for these child support payments?',
        },
      },
      appendTitle: 'Do you have another instance where you are or were over 120 days past due on child support payments in the past five years?',
    },
    civilJudgement: {
      summary: {
        title: 'Summary of civil judgements',
        type: 'Civil judgement',
        unknown: 'Provide your civil judgement details',
      },
      branch: {
        title: 'In the past five years, have you had a civil judgment entered against you? (This applies whether you are the sole debtor, a cosigner, or guarantor for the debt. A guarantor is an individual who is able and willing to take financial responsibility if the debtor or cosigner defaults on their financial obligation.)',
        ifYes: {
          amountTextEstimated: 'How much was the judgment for (in U.S. dollars)?',
          whyTextArea: 'Why was this judgment entered against you?',
          whenDateEstimated: 'When was this judgment entered against you?',
          branch: {
            title: 'Did you pay this judgment in full?',
            ifYes: {
              whenDateEstimated: 'When did you pay this judgment in full?',
            },
            ifNo: {
              combobox: {
                actionsTaken: 'What actions have you taken to pay this judgment in full?',
              },
              explainTextArea: 'Please explain.',
            },
          },
          courtNameText: 'What is the name of the court involved? (Do not use acronyms or abbreviations.)',
          courtLocation: 'What is this court\'s address?',
          orderNumTextIdk: 'What is the court docket or order number for this civil judgment?',
          otherPartiesTextArea: 'Who are the parties (besides yourself) listed in this civil judgment?',
        },
      },
      appendTitle: 'Do you have another instance where a civil judgment was entered against you in the '
      + 'past five years? (This applies whether you are the sole debtor, a cosigner, or guarantor for '
      + 'the debt. A guarantor is an individual who is able and willing to take financial responsibility '
      + 'if the debtor or cosigner defaults on their financial obligation.)',
    },
    lien: {
      summary: {
        title: 'Summary of liens',
        type: 'Lien',
        unknown: 'Provide your lien details',
      },
      branch: {
        title: 'In the past five years, have you had a lien placed against your property for failing to pay a debt? (This applies whether you are the sole debtor, a cosigner, or guarantor for the debt. A guarantor is an individual who is able and willing to take financial responsibility if the debtor or cosigner defaults on their financial obligation.)',
        ifYes: {
          entityTypeRadioGroup: {
            title: 'What type of entity placed this lien against your property?',
            ifCompGovOrEntityText: 'What is the name of the company, government agency, or other entity that placed '
            + 'the lien against your property? (Do not use acronyms or abbreviations.)',
            ifPrivateText: 'Who placed the lien against your property?',
            ifOther: 'Please explain.',
          },
          propertyTypeRadioGroup: {
            title: 'What type of property was this lien placed against?',
            ifOther: 'Please explain.',
          },
          whyRadioGroup: {
            title: 'Why was this lien placed against your property?',
            ifOther: 'Please explain.',
          },
          amountCurrency: 'How much money do you or did you owe the lienholder (in U.S. dollars)? • A '
          + 'lienholder is the entity that has a legal claim, hold, or charge against your property for '
          + 'satisfaction of a debt. Examples of a lienholder are a mortgage company, auto financing '
          + 'company, child support enforcement agency, credit card company, bank, credit union, financial '
          + 'institution, the IRS, or a private party or individual.',
          whenDateEstimated: 'When was this lien placed against you?',
          branch: {
            title: 'Is this lien still placed against your property?',
            ifNo: {
              whenDateEstimated: 'When was this lien resolved?',
            },
            ifYes: {
              combobox: {
                actionsTaken: 'What actions have you taken to resolve this lien?',
                ifNone: 'Please explain.',
              },
            },
          },
          officeNameText: 'What is the name of the government office where the lien is recorded? (Do not use acronyms or abbreviations.)',
          officeLocation: 'What is the address for this government office?',
          caseNumText: 'What is the case or document number associated with this lien?',
        },
      },
      appendTitle: 'Do you have another instance where a lien was placed against your property for failing '
      + 'to pay a debt in the past five years? (This applies whether you are the sole debtor, a cosigner, '
      + 'or guarantor for the debt. A guarantor is an individual who is able and willing to take financial '
      + 'responsibility if the debtor or cosigner defaults on their financial obligation.)',
    },
    foreclosure: {
      summary: {
        title: 'Summary of foreclosures',
        type: 'Foreclosure',
        unknown: 'Provide your foreclosure details',
      },
      branch: {
        title: 'In the past five years, have you had any property foreclosed on? (This applies whether you are the sole debtor, a cosigner, or guarantor for the debt. A guarantor is an individual who is able and willing to take financial responsibility if the debtor or cosigner defaults on their financial obligation.)'
        + '• Foreclosure is a process that allows lenders to take ownership of a mortgaged property from the borrower. This is typically real estate (such as land, a home, or other building) in which the forrow has defaulted on the load. (B23.6)',
        ifYes: {
          whoRadioGroup: {
            title: 'Did a public or government entity or a private party foreclose on your property?',
            isPublicOrGov: 'What is the name of the lender that foreclosed on your property? (Examples of '
            + 'commercial lenders include banks and credit unions whereas examples of government lenders '
            + 'include Fannie Mae, Freddie Mac, or the Veteran\'s Administration (VA). Do not use acronyms or abbreviations.)',
            isPrivateName: 'Who foreclosed on your property?',
            isOther: 'Please explain.',
          },
          propertyTypeRadioGroup: {
            title: 'What type of property was foreclosed on?',
            ifOther: 'Please explain.',
          },
          propertyLocation: 'What is the address of the property that was foreclosed on?',
          missedPayments: {
            whenFirstDateEstimated: 'When was your first missed mortgage payment?',
            numberMissedText: 'How many mortgage payments did you miss?',
          },
          amountOwedText: 'How much money do or did you owe the lender (in U.S. dollars)?',
          whyStoppedTextArea: 'Why did you stop making mortgage payments?',
          whenDateEstimated: 'When was your property foreclosed on?',
          branch: {
            title: 'Do you still owe money to the lender on this property?',
            ifNo: {
              whenClosedDateEstimated: 'When was this case closed?',
            },
            ifYes: {
              combobox: {
                actionsTaken: 'What actions have you taken to pay the lender?',
                ifNone: 'Please explain.',
              },
            },
          },
          courtNameTextNotApplicable: 'What is the name of the court involved? (Do not use acronyms or abbreviations.)',
          courtLocation: 'What is this court\'s address?',
          orderNumTextIdk: 'What is the court docket or order number associated with this foreclosure?',
        },
      },
      appendTitle: 'Do you have another instance where your property was foreclosed on in the past five '
      + 'years? (This applies whether you are the sole debtor, a cosigner, or guarantor for the debt. A '
      + 'guarantor is an individual who is able and willing to take financial responsibility if the debtor '
      + 'or cosigner defaults on their financial obligation.)',
    },
    repossession: {
      summary: {
        title: 'Summary of repossessions',
        type: 'Repossession',
        unknown: 'Provide your repossession details',
      },
      branch: {
        title: 'Have you had any possessions or property repossessed in the past five years? (This '
        + 'applies whether you are the sole debtor, a cosigner, or guarantor for the debt. A guarantor is '
        + 'an individual who is able and willing to take financial responsibility if the debtor or cosigner '
        + 'defaults on their financial obligation.) • Repossession is a process that allows lienholders to '
        + 'recover specific possessions or property after a buyer defaults on payments. The possessions or '
        + 'property that are repossessed are typically bought on a payment plan via a contract (such as, '
        + 'vehicles, jewelry, furniture) as opposed to real estate that is foreclosed upon when the borrower '
        + 'defaults on payments.',
        ifYes: {
          lenderNameText: 'What is the name of the lender that repossessed your property? (Do not use acronyms or abbreviations.)',
          propertyTypeRadioGroup: {
            title: 'What type of property was repossessed?',
            ifOther: 'Please explain.',
          },
          missedPayments: {
            whenFirstDateEstimated: 'When was your first missed payment to the lender?',
            numberMissedText: 'How many payments did you miss prior to the repossession?',
          },
          amountOwedText: 'How much money do or did you owe the lender? (in U.S. dollars)',
          whyTextArea: 'Why did you stop making payments to the lender?',
          whenDateEstimated: 'When was your property repossessed?',
          accountNumText: 'What is the account number associated with this repossession?',
          branch: {
            title: 'Do you still owe money to the lender for this property?',
            ifNo: {
              whenClosedDateEstimated: 'When was this account closed?',
            },
            ifYes: {
              combobox: {
                actionsTaken: 'What actions have you taken to pay the lender?',
                ifNone: 'Please explain.',
              },
            },
          },
          courtNameTextNotApplicable: 'What is the name of the court involved? (Do not use acronyms or abbreviations.)',
          courtLocation: 'What is this court\'s address?',
          orderNumTextIdk: 'What is the court docket or order number associated with this repossession?',
        },
      },
      appendTitle: 'Do you have another instance where you had possessions or property repossessed in '
      + 'the past five years? (This applies whether you are the sole debtor, a cosigner, or guarantor '
      + 'for the debt. A guarantor is an individual who is able and willing to take financial '
      + 'responsibility if the debtor or cosigner defaults on their financial obligation.)',
    },
    eviction: {
      summary: {
        title: 'Summary of evictions',
        type: 'Eviction',
        unknown: 'Provide your eviction details',
      },
      branch: {
        title: 'In the past five years, were you evicted from a rental property? (This applies whether you are the sole signer or a cosigner on the contract.)',
        ifYes: {
          entityTypeRadioGroup: {
            title: 'What type of entity evicted you from this rental property?',
            ifCompanyAgencyOrEntityText: 'What is the name of the company, government agency, or other '
            + 'entity that evicted you from the rental property? (Do not use acronyms or abbreviations.)',
            ifPrivateText: 'Who evicted you from the property?',
            ifOtherTextArea: 'Please explain.',
          },
          propertyLocation: 'What is the address of the property you were evicted from?',
          hasMissedRent: 'Did you miss any rental payments?',
          missedPayments: {
            whenFirstDateEstimated: 'When was your first missed rental payment?',
            numberMissedText: 'How many rental payments did you miss?',
          },
          amountOwedTextEstimated: 'How much money do or did you owe (in U.S. dollars)?',
          whyTextArea: 'Why did you stop making rental payments?',
          whenDateEstimated: 'When were you evicted?',
          branch: {
            title: 'Do you still owe money to the entity or private individual you named above?',
            ifNo: {
              whenDateEstimated: 'When did you satisfy this debt?',
            },
            ifYes: {
              combobox: {
                actionsTaken: 'What actions have you taken to pay this debt?',
                ifNoneTextArea: 'Please explain.',
              },
            },
          },
          courtNameTextNotApplicable: 'What is the name of the court involved? (Do not use acronyms or abbreviations.)',
          courtLocation: 'What is this court\'s address?',
          orderNumTextIdk: 'What is the court docket or order number associated with this eviction?',
        },
      },
      appendTitle: 'Do you have another instance where you were evicted from a rental property in the past '
      + 'five years? (This applies whether you are the sole signer or a cosigner on the contract.)',
    },
    assetSeized: {
      summary: {
        title: 'Summary of asset seizures',
        type: 'Asset Seized',
        unknown: 'Provide your asset seizure details',
      },
      branch: {
        title: 'In the past five years, have you had any of your wages, benefits, or assets seized? (Examples include wage garnishments, retirement benefit garnishments, or seizures of money from a bank account. Do not list foreclosures or repossessions you listed above.)',
        ifYes: {
          combobox: {
            seizureType: 'Which one was seized? (There will be an opportunity to input multiple entries.)',
            ifOtherTextArea: 'Please explain.',
          },
          whyTextArea: 'Why were these wages, benefits, or assets seized?',
          whenDateEstimated: 'When were these wages, benefits, or assets seized?',
          amountOwedTextEstimated: 'How much money do or did you owe (in U.S. dollars)?',
          branch: {
            title: 'Do you still owe money on this debt?',
            ifNo: {
              whenDateEstimated: 'When did you resolve this debt?',
            },
            ifYes: {
              combobox: {
                actionsTaken: 'What actions have you taken to resolve this debt?',
                ifNone: 'Please explain.',
              },
            },
          },
          courtNameTextNotApplicable: 'What is the name of the court involved? (Do not use acronyms or abbreviations.)',
          courtLocation: 'What is this court\'s address?',
          orderNumTextIdk: 'What is the court docket or order number associated with this asset seizure?',
        },
      },
      appendTitle: 'Do you have another instance where your wages, benefits, or assets were seized in the '
      + 'past five years? (Examples include wage garnishments, retirement benefit garnishments, or '
      + 'seizures of money from a bank account. Do not list foreclosures or repossessions you listed above.)',
    },
    nonpaymentNonfederal: {
      summary: {
        title: 'Summary of non-federal payment issues',
        type: 'Nonpayment Nonfederal',
        unknown: 'Provide your non-federal payment issue details',
      },
      branch: {
        title: 'In the past five years, have you failed to pay any non-federal taxes? (Examples of non-federal taxes include state and local taxes, property taxes, and personal property taxes.) Answer "No" if you 1) were not required to pay because you did not earn enough money, 2) did not owe money (you received or were entitled to a refund), or 3) were not required by law or ordinance to file or pay these taxes.)',
        ifYes: {
          typeCombobox: {
            taxType: 'What type of taxes did you fail to pay in the past five years?',
            ifOther: 'Please explain.',
          },
          whenFailDate: 'What tax year did you fail to pay?',
          whenFileDate: 'When was the filing date for these taxes?',
          pvqABC: {
            branch: {
              title: 'Have you since paid these taxes in full?',
              ifYes: {
                resolved: 'When did you pay these taxes in full?',
              },
            },
            whenFiledEstimated: 'When did you file these taxes?',
          },
          amountOwedTextIdk: 'How much do you owe (in U.S. dollars)?',
          actionsCombobox: {
            actionsTaken: 'What actions have you taken to pay these taxes? (Select all that apply.)',
            ifNoneOrOtherTextArea: 'Please explain.',
          },
        },
      },
      appendTitle: 'Do you have another instance in the past five years, where you have failed to pay any non-federal taxes? (Examples of non-federal taxes include state and local taxes, property taxes, and personal property taxes.) Answer "No" if you 1) were not required to pay because you did not earn enough money, 2) did not owe money (you received or were entitled to a refund), or 3) were not required by law or ordinance to file or pay these taxes.)',
    },
    violatedCardTerm: {
      branch: {
        title: 'In the past five years, were you disciplined for violating the terms of a government or employer travel card or credit card?',
        ifYes: {
          agencyNameText: 'What is the name of the government agency or the employer where you were disciplined? (Do not use acronyms or abbreviations in the name.)',
          branch: {
            title: 'Is this government agency or employer located in the U.S.?',
            ifYes: {
              agencyLocation: 'What is the address for this government agency or employer?',
              branch: {
                title: 'Is this a U.S. military installation?',
                ifYes: {
                  installationNameText: 'What is the name of the U.S. military installation?',
                },
              },
            },
            ifNo: {
              agencyLocation: 'Where is this government agency or employer located?',
              branch: {
                title: 'Is this a U.S. military installation or U.S. diplomatic facility?',
                ifYes: {
                  installationNameTextNotApplicable: 'What is the name of the U.S. military installation or U.S. diplomatic facility?',
                  installationLocation: 'What is the APO/FPO/DPO ZIP Code for the U.S. military installation or U.S. diplomatic facility?',
                },
              },
            },
          },
          disciplineCheckboxGroup: {
            title: 'What type of disciplinary action did you receive? (Select all that apply.)',
            ifNoActionsOrOtherTextArea: 'Please explain.',
          },
          whenDateEstimated: 'When did you receive this disciplinary action?',
          amountOwedCurrencyEstimated: 'How much money was involved? (in U.S. dollars)',
          additionalDetailsTextArea: 'What were the circumstances surrounding your travel or credit card '
          + 'violation? (Include whether you knowingly violated the terms of the travel or credit card, '
          + 'how many times you violated the terms, why you violated the terms, and any other details you think are important.)',
          actionsTakenCheckboxGroup: {
            title: 'What actions have you taken to address this situation? (Select all that apply.)',
            ifOther: 'Please explain.',
          },
          accountNum: 'What is the loan or account number associated with this debt?',
        },
      },
      appendTitle: 'Do you have another instance in which you were disciplined for violating the terms '
      + 'of a government or employer travel card or credit card in the past five years?',
    },
    pastDueDebt: {
      branch: {
        title: 'In the past five years, are you or were you more than 120 days past due on any debts? '
        + '(Include only those not listed above) (This applies whether you are the sole debtor, a '
        + 'cosigner, or guarantor for the debt. A guarantor is an individual who is able and willing to '
        + 'take financial responsibility if the debtor or cosigner defaults on their financial obligation.)',
      },
      ifYes: {
        debtNameText: 'What debt(s) are you or were you 120 days past due on? (Include the name of the company, '
        + 'government agency, or individual you owe or owed. If you have more than one debt, input one. There '
        + 'will be an opportunity to input multiple entries.)',
        whyTextArea: 'Why are you or were you past due on this debt?',
        amountTextEstimated: 'How much money do or did you owe (in U.S. dollars)?',
        missedPayments: {
          whenFirstDateEstimated: 'When was your first missed payment?',
        },
        branch: {
          title: 'Are you still over 120 days past due on this debt?',
          ifNo: {
            whenDateEstimated: 'When did you resolve this debt?',
          },
          ifYes: {
            combobox: {
              actionsTaken: 'What actions have you taken to resolve this debt?',
              ifNone: 'Please explain.',
            },
          },
        },
        amountCurrencyIdk: 'What is the loan or account number associated with this debt?',
      },
      appendTitle: 'Do you have another instance where you are or were in the past five years, over 120 '
      + 'days past due on a debt not previously listed? (This applies whether you are the sole debtor, a '
      + 'cosigner, or guarantor for the debt. A guarantor is an individual who is able and willing to take '
      + 'financial responsibility if the debtor or cosigner defaults on their financial obligation.)',
    },
    counseling: {
      branch: {
        title: 'Are you currently using a credit counseling service, debt consolidation service, or other '
        + 'similar service to resolve any past due financial obligations?',
        ifYes: {
          serviceNameText: 'What is the name of this credit counseling service, debt consolidation '
          + 'service, or other similar service? (Do not use acronyms or abbreviations in the name.)',
          branch: {
            title: 'Is this service located in the U.S.?',
            ifYes: {
              serviceLocation: 'What is the address of this service?',
              branch: {
                title: 'Is this a U.S. military installation?',
                ifYes: {
                  installationNameText: 'What is the name of the U.S. military installation?',
                },
              },
            },
            ifNo: {
              serviceLocation: 'Where is this service located?',
              branch: {
                title: 'Is this a U.S. military installation or U.S. diplomatic facility?',
                ifYes: {
                  apoFpoDpoZipText: 'What is the APO/FPO/DPO ZIP Code for the U.S. military installation '
                  + 'or U.S. diplomatic facility?',
                },
              },
            },
          },
          servicePhone: 'What is the phone number for this service?',
          effectivenessBranch: {
            title: 'Has this credit counseling service, debt consolidation service, or other similar '
            + 'service been effective in helping you resolve your past due financial obligations?',
            ifYesOrNo: {
              howTextArea: 'How?',
              whyTextArea: 'Why?',
            },
          },
        },
      },
      appendTitle: 'Do you have another instance of financial counseling to report?',
    },
    intro: {
      title: 'Financial record',
      body:
      'This section asks for information regarding your finances to include any bankruptcies, judgments, '
      + 'liens, foreclosures, repossessions, evictions, charged-off accounts, debts over 120-days past due, '
      + 'including alimony or child support payments, and any wage, benefit, or asset seizures, as applicable. '
      + 'We also want to know what activities you have taken to address any past due financial obligations. '
      + 'For this section, the term past due:',
      bullet1: 'Means a payment was not made by its due date, or by the end of the grace period, if applicable.',
      bullet2: 'For credit card accounts, past due means the minimum required payment was not applied '
      + 'to the account as of the due date, or by the end of the grace period, if applicable.',
      bullet3: 'For other debts paid in installments, such as loans, past due means a payment was not '
      + 'made by its due date or by the end of the grace period.',
    },
  },
  intro: {
    title: 'Financial record',
    body:
      'You will be asked questions about your financial history and be asked to provide details if necessary.',
  },
  tour: {
    para: 'Take a guided tour through the section',
  },
  review: {
    para: 'View all the sections associated with identification at once',
  },
  section: {
    name: 'Financial record',
  },
  subsection: {
    intro: 'Introduction',
    bankruptcy: 'Bankruptcy',
    gambling: 'Gambling',
    taxes: 'Taxes',
    card: 'Employer card abuse',
    credit: 'Credit counseling',
    delinquent: 'Delinquent payments',
    nonpayment: 'Non-payment consequence',
    alimony: 'Alimony',
    childsupport: 'Child support',
    civiljudgement: 'Civil judgement',
    lien: 'Lien',
    foreclosure: 'Foreclosure',
    repossession: 'Repossession',
    federaldebt: 'Federal debt',
    eviction: 'Eviction',
    nonpaymentnonfederal: 'Nonpayment nonfederal',
    assetseized: 'Asset seized',
    review: 'Review',
  },
  destination: {
    intro: 'Financial intro',
    gambling: 'Gambling',
    bankruptcy: 'Bankruptcy',
    taxes: 'Taxes',
    card: 'Employer card abuse',
    credit: 'Credit counseling',
    delinquent: 'Delinquent payments',
    nonpayment: 'Non-payment consequence',
    alimony: 'Alimony',
    childsupport: 'Child support',
    civiljudgement: 'Civil judgement',
    lien: 'Lien',
    foreclosure: 'Foreclosure',
    repossession: 'Repossession',
    federaldebt: 'Federal debt',
    eviction: 'Eviction',
    nonpaymentnonfederal: 'Nonpayment nonfederal',
    assetseized: 'Asset seized',
    review: 'Review Financial record',
  },
  gambling: {
    title: 'Have you ever experienced financial problems due to gambling?',
    titleWithNum:
      'In the last {{numberOfYearsString}} have you ever experienced financial problems due to gambling?',
    branch: {
      help: {
        title: 'Need more information on gambling?',
        message: 'Select whether you have experienced any financial problems due to gambling',
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of financial problems',
        unknownlosses: 'Provide your financial problem details',
        present: 'Now',
        nodates: 'NA',
        debt: 'Debt',
      },
      append: 'Add another financial problem',
      appendTitle: 'Have you EVER experienced additional financial problems due to gambling?',
    },
    heading: {
      dates: 'Provide the date range of your financial problems due to gambling',
      losses: 'Provide an estimate of the amount (in U.S. dollars) of gambling losses incurred',
      description: 'Provide a description of your financial problems due to gambling',
      actions:
        'If you have taken any action(s) to rectify your financial problems due to gambling, provide a description of your actions. If you have not taken any action(s) provide an explanation.',
    },
    label: {
      dates: 'Dates of debt',
      losses: 'Losses',
      description: 'Description',
      actions: 'Action(s) taken or explanation',
    },
    help: {
      dates: {
        title: 'Need help with the dates?',
        message: 'Provide the date range of your financial problems due to gambling',
        note: '',
      },
      losses: {
        title: 'Need help gambling losses?',
        message: 'Enter estimate of the amount (in U.S. dollars) of gambling losses incurred',
        note: '',
      },
      description: {
        title: 'Full explanation of this financial problem',
        message: 'Go into as much detail as you need to fully explain.',
        note: '',
      },
      actions: {
        title: 'Have you started trying to fix this problem?',
        message:
          "Explain what you have done to fix this problem. If you haven't started yet tell us why.",
        note: '',
      },
      comments: {
        title: 'Need help providing additional information?',
        message:
          'If you need to provide any additional comments about this information enter them below',
        note: '',
      },
    },
  },
  bankruptcy: {
    collection: {
      summary: {
        title: 'Summary of Bankruptcy',
        item: 'Petition',
        unknown: 'Provide your petition details below',
        nodates: 'NA',
        chapter: 'Chapter',
        appendTitle:
          'In the last seven (7) years, have you filed any additional petitions under any chapter of the bankruptcy code?',
      },
      append: 'Add another petition',
    },
    heading: {
      petitionType: 'Select the applicable bankruptcy petition type',
      courtNumber: 'Provide the bankruptcy court docket/account number',
      dateFiled: 'Provide the date bankruptcy was filed',
      dateDischarged: 'Provide the date of bankruptcy discharge',
      totalAmount: 'Provide the total amount (in U.S. dollars) involved in the bankruptcy',
      nameDebt: 'Provide the name the debt is recorded under',
      courtInvolved: 'Provide the name of the court involved',
      courtAddress: 'Provide the address of the court involved',
      dischargeExplanation: 'Were you discharged of all debts claimed in the bankruptcy?',
    },
    para: {
      or: 'or',
    },
    label: {
      idk: "I don't know",
      dischargeExplanation: 'Provide explanation',
      confirmation: 'Are you sure you would like to change your answer? This will remove any data currently entered.',
    },
    title:
      'In the last seven (7) years have you filed a petition under any chapter of the bankruptcy code?',
    notApplicable: 'Not applicable',
    help: {
      title: 'Chapter 7, Chapter 11, Chapter 12, or Chapter 13',
      message:
        'Answer yes if you filed a petition under Chapter 7, Chapter 11, Chapter 12, or Chapter 13.',
      note: 'Note: You will be asked to provide details of the petition or petitions.',
    },
    petitionType: {
      label: {
        chapter7: 'Chapter 7',
        chapter11: 'Chapter 11',
        chapter12: 'Chapter 12',
        chapter13: 'Chapter 13',
      },
      help: {
        title: 'Need help with the details of your bankruptcy petition?',
        message: [
          "If you don't have paperwork you may be able to find your details here: [www.pacer.gov](https://www.pacer.gov/)",
        ],
        note: '',
      },
    },
    dateDischarged: {
      help: {
        title: 'Need help with the date of bankruptcy discharge?',
        message: 'Provide the date of bankruptcy discharge',
        note: '',
      },
    },
    dateFiled: {
      help: {
        title: 'Need help with the date the bankruptcy was filed?',
        message: 'Provide the date bankruptcy was filed',
        note: '',
      },
    },
    courtNumber: {
      title: 'Court docket/account number',
      label: 'Number',
      help: {
        title: 'Need help with the docker or account number?',
        message: 'Provide the docket/account number',
        note: '',
      },
    },
    totalAmount: {
      label: 'Amount',
      help: {
        title: 'Need help with the total amount?',
        message: 'Provide the total amount (in U.S. dollars) involved in the bankruptcy',
        note: '',
      },
      estimated: 'Estimated',
    },
    courtInvolved: {
      label: 'Court name',
      help: {
        title: 'Need help with the court name?',
        message: 'Provide the name of the court involved',
        note: '',
      },
    },
    trustee: {
      title: 'Provide the name of the trustee for this bankruptcy',
      label: 'Trustee name',
      help: {
        title: 'Need help with the trustee name?',
        message:
          'The trustee refers to the person who holds authority or a position of trust or responsibility appointed to the bankruptcy',
        note: '',
      },
      address: {
        title: 'Provide the address of the trustee for this bankruptcy',
        label: 'Trustee address',
        help: {
          title: 'Need help with the trustee address?',
          message: 'The address of the trustee involved for this bankruptcy',
          note: '',
        },
      },
    },
    courtAddress: {
      label: 'This address is',
      help: {
        title: 'Try looking up the facility name, this could help you find the address',
        message: 'If you can only find a phone number try calling and asking for the address.',
        note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
      },
    },
  },
  taxes: {
    title:
      'In the last {{yearsString}} ({{years}}) years have you failed to file or pay Federal, state, or other taxes when required by law or ordinance?',
    heading: {
      failure: 'Did you fail to file, pay as required, or both?',
      year:
        'Provide the year you failed to file or pay your federal, state, or other taxes (Estimated)',
      reason: 'Provide the reason(s) for your failure to file or pay required taxes',
      agency:
        'Provide the Federal, state, or other agency to which you failed to file or pay taxes',
      taxtype:
        'Provide the type of taxes you failed to file or pay (such as property, income, sales, etc.)',
      amount: 'Provide the amount (in U.S. dollars) of the taxes',
      date: 'Provide the date satisfied',
      description:
        'Provide a description of any action(s) you have taken to satisfy this debt (such as withholdings, frequency and amount of payments, etc.). If you have not taken any action(s) provide explanation.',
    },
    label: {
      file: 'File',
      pay: 'Pay',
      both: 'Both',
      estimated: 'Estimated',
      notapplicable: 'Not applicable',
    },
    para: {
      or: 'or',
    },
    help: {
      branch: {
        title: 'Need help with the type of tax failure?',
        message:
          'If you have failed to file or pay any federal, state, or other taxes required by law or ordinance within the last seven (7) years click "Yes"',
        note: '',
      },
      failure: {
        title: 'Need help with the type of tax failure?',
        message: 'Provide the type of tax failure',
        note: '',
      },
      year: {
        title: 'Need help with the year?',
        message: 'Provide the year you failed to file or pay your taxes',
        note: '',
      },
      reason: {
        title: 'Need help with the reason?',
        message: 'Provide the reason for the failure to file or pay the required taxes',
        note: '',
      },
      agency: {
        title: 'Need help with the agency?',
        message: 'Provide the name of the agency to which the taxes were failed to file or pay to',
        note: '',
      },
      taxtype: {
        title: 'Need help with tax type?',
        message:
          'Provide the type of taxes you failed to file or pay such as property, income, sales, etc.',
        note: '',
      },
      amount: {
        title: 'Need help with the amount?',
        message: 'Provide the amount, in U.S. dollars, of taxes',
        note: '',
      },
      date: {
        title: 'Need help with the date satisfied?',
        message: 'Provide the date, if any, the tax issue was satisfied',
        note: '',
      },
      description: {
        title: 'Have you started trying to fix this problem?',
        message:
          "Explain what you have done to fix this problem. If you haven't started yet tell us why.",
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of failed tax filings',
        unknown: 'Provide your tax filing information below',
        item: 'Agency',
      },
      appendTitle:
        'Are there any other instances in the last {{yearsString}} ({{years}}) years where you failed to file or pay Federal, state, or other taxes when required by law or ordinance?',
      append: 'Add another tax filing/payment issue',
    },
  },
  card: {
    title:
      'In the last seven (7) years have you been counseled, warned, or disciplined for violating the terms of agreement for your travel or credit card provided by your employer?',
    heading: {
      agency: 'Provide the name of the agency or company',
      address: 'Provide the address of the agency or company',
      date: 'Provide the date of your counseling, warning, or disciplinary action',
      reason: 'Provide the reason(s) for the counseling, warning, or disciplinary action',
      amount: 'Provide the amount (in U.S. dollars) of violation',
      description:
        'Provide a description of any action(s) you have taken to rectify this situation. If you have not taken any action(s) provide explanation.',
    },
    label: {
      estimated: 'Estimated',
    },
    help: {
      branch: {
        title: 'Need help with the employer card abuse?',
        message:
          'If in the last seven (7) years have you been counseled, warned, or disciplined for violating the terms of agreement for your travel or credit card provided by your employer then click "Yes"',
        note: '',
      },
      agency: {
        title: 'Need help with the agency or company name?',
        message: 'Provide the name of the agency or company involved',
        note: '',
      },
      address: {
        title: 'Try looking up the agency or company name, this could help you find the address',
        message: 'If you can only find a phone number try calling and asking for the address.',
        note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
      },
      date: {
        title: 'Need help with the date?',
        message: 'Provide the approximate date of the violation',
        note: '',
      },
      reason: {
        title: 'Need help with the reason?',
        message: 'Provide the reason for the violation',
        note: '',
      },
      amount: {
        title: 'Need help with the amount?',
        message: 'Provide the amount, in U.S. dollars, of violation',
        note: '',
      },
      description: {
        title: 'Need help providing a description?',
        message:
          "Tell us if you have started trying to fix this issue. If you haven't started yet tell us why.",
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of employer card abuses',
        unknown: 'Provide your card abuse information below',
        item: 'Employer',
      },
      appendTitle:
        'Are there any other instances in the last seven (7) years where you have been counseled, warned, or disciplined for violating the term of agreement for a travel or credit card provided by your employer?',
      append: 'Add another card abuse/counseling issue',
    },
  },
  credit: {
    title:
      'Are you currently utilizing, or seeking assistance from, a credit counseling service or other similar resource to resolve your financial difficulties?',
    heading: {
      explanation: 'Provide explanation',
      name: 'Provide the name of the credit counseling organization or resource',
      telephone: 'Provide the phone number of the credit counseling organization',
      address: 'Provide the location of the credit counseling organization',
      description:
        'As a result of this counseling provide a description of any action(s) you have taken to resolve your financial difficulties. If you have not taken any action(s) provide explanation.',
    },
    help: {
      branch: {
        title: 'Need help with credit counseling?',
        message:
          'If you currently utilizing, or seeking assistance from, a credit counseling service or other similar resource to resolve your financial difficulties then click "Yes"',
        note: '',
      },
      explanation: {
        title: 'Full explanation of this credit counseling',
        message: 'Go into as much detail as you need to fully explain.',
        note: '',
      },
      name: {
        title: 'Need help with the counseling organization name?',
        message: 'Provide the name of the counseling organization',
        note: '',
      },
      telephone: {
        title: 'Look up the organization',
        message: "Try looking up the organization's name, this could help you find their number.",
        note: '',
      },
      address: {
        title: 'Look up the organization',
        message: "Try looking up the organization's name, this could help you find the address.",
        note: 'Note: If you can only find a phone number try calling and asking for the address.',
      },
      description: {
        title: 'Have you started trying to fix this problem?',
        message:
          "Explain what you have done to fix this problem. If you haven't started yet tell us why.",
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of credit counseling',
        unknown: 'Provide your credit counseling details below',
        item: 'Service',
      },
      appendTitle:
        'Are you currently utilizing, or seeking assistance from any other credit counseling service or similar resource to resolve your financial difficulties?',
      append: 'Add another credit counseling entry',
    },
  },
  delinquent: {
    title: 'Other than previously listed, has the following happened to you?',
    para: {
      details:
        'You will be asked to provide details about each financial obligation that pertains to the items identified below.',
      alimony:
        '**In the last {{yearsString}} ({{years}}) years,** you have been delinquent on alimony or child support payments.',
      alimonySF85P: 'You are currently delinquent on alimony or child support payments.',
      judgement:
        '**In the last {{yearsString}} ({{years}}) years,** you had a judgment entered against you. (Include financial obligations for which you were the sole debtor, as well as those for which you were a cosigner or guarantor).',
      lien:
        '**In the last {{yearsString}} ({{years}}) years,** you had a lien placed against your property for failing to pay taxes or other debts. (Include financial obligations for which you were the sole debtor, as well as those for which you were a cosigner or guarantor).',
      federal:
        'You are currently delinquent on any Federal debt. (Include financial obligations for which you were the sole debtor, as well as those for which you were a cosigner or guarantor).',
      or: 'or',
      checkAll: 'Check all that apply',
    },
    heading: {
      name: 'Provide the name of agency/organization/individual to which debt is/was owed',
      infractions: 'Did/does this financial issue include any of the following:',
      accountnumber: 'Provide the associated loan / account number(s) involved',
      propertytype: 'Identify/describe the type of property involved (if any)',
      amount: 'Provide the amount (in U.S. dollars) of the financial issue',
      reason: 'Provide the reason(s) for the financial issue',
      status: 'Provide the current status of the financial issue',
      date: 'Provide the date the financial issue began',
      resolved: 'Provide the date the financial issue was resolved',
      courtname: 'Provide the name of the court involved',
      courtaddress: 'Provide the address of the court involved',
      description:
        'Provide a description of any action(s) you have taken to satisfy this debt (such as withholdings, frequency and amount of payments, etc.). If you have not taken any provide explanation.',
      accountNumberExplanation: 'Provide the explanation for account number',
      courtNameExplanation: 'Provide the explanation for court name',
      courtAddressExplanation: 'Provide the explanation for court address'
    },
    label: {
      idk: "I don't know",
      notresolved: 'Not resolved',
      estimated: 'Estimated',
      confirmation: 'Are you sure you would like to change your answer? This will remove any data currently entered.',
    },
    help: {
      branch: {
        title: 'Need help with delinquent payments?',
        message: 'If you have had in of the listed items happen to you then select "Yes"',
        note: '',
      },
      name: {
        title: 'Need help with the name of the agency, organization, or individual?',
        message: 'Provide the name of the agency, organization, or individual',
        note: '',
      },
      infractions: {
        title: 'Need help with types of financial issues?',
        message: 'Select all of the financial issues which applies to this issue',
        note: '',
      },
      accountnumber: {
        title: 'Need help with the associated loan or account number(s)?',
        message: 'Provide the associated loan or account number(s)',
        note: '',
      },
      propertytype: {
        title: 'Need help with the type of property?',
        message: 'Provide a description of the type of property involved, if any',
        note: '',
      },
      amount: {
        title: 'Need help with the financial issue amount?',
        message: 'Provide the approximate amount of the financial issue',
        note: '',
      },
      reason: {
        title: 'Full explanation of this issue',
        message: 'Go into as much detail as you need to fully explain.',
        note: '',
      },
      status: {
        title: 'Need help with the current status?',
        message: 'Provide a description of the current status of the financial issue',
        note: '',
      },
      date: {
        title: 'Need help with the beginning date?',
        message: 'Provide the approximate date the financial issue began',
        note: '',
      },
      resolved: {
        title: 'Need help with the resolved date?',
        message: 'Provide the approximate date, if available, the financial issue was resolved',
        note: '',
      },
      courtname: {
        title: 'Need help with the court name?',
        message: 'Provide the name of the court involved',
        note: '',
      },
      courtaddress: {
        title: 'Try looking up the court name, this could help you find the address',
        message: 'If you can only find a phone number try calling and asking for the address.',
        note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
      },
      description: {
        title: 'Have you started trying to fix this problem?',
        message:
          "Explain what you have done to fix this problem. If you haven't started yet tell us why.",
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of delinquent payment issues',
        unknown: 'Provide your payment issue details below',
        item: 'Service',
      },
      appendTitle:
        'Other than previously listed, are there any other instances of the following occurrences?',
      append: 'Add another payment issue',
    },
  },
  nonpayment: {
    title: 'Other than previously listed, have any of the following happened?',
    para: {
      repo:
        '**In the last seven (7) years,** you had any possessions or property voluntarily or involuntarily repossessed or foreclosed? (Include financial obligations for which you were the sole debtor, as well as those for which you were a cosigner or guarantor).',
      defaulted:
        '**In the last seven (7) years,** you defaulted on any type of loan? (Include financial obligations for which you were the sole debtor, as well as those for which you were a cosigner or guarantor).',
      collections:
        '**In the last seven (7) years,** you had bills or debts turned over to a collection agency? (Include financial obligations for which you were the sole debtor, as well as those for which you were a cosigner or guarantor).',
      cancelled:
        '**In the last seven (7) years,** you had any account or credit card suspended, charged off, or cancelled for failing to pay as agreed? (Include financial obligations for which you were the sole debtor, as well as those for which you were a cosigner or guarantor).',
      evicted: '**In the last seven (7) years,** you were evicted for non-payment?',
      garnished:
        '**In the last seven (7) years,** you had your wages, benefits, or assets garnished or attached for any reason?',
      delinquent:
        '**In the last seven (7) years,** you have been over 120 days delinquent on any debt not previously entered? (Include financial obligations for which you were the sole debtor, as well as those for which you were a cosigner or guarantor).',
      any:
        'You are currently over 120 days delinquent on any debt? (Include financial obligations for which you were the sole debtor, as well as those for which you were a cosigner or guarantor).',
      or: 'or',
      checkAll: 'Check all that apply',
    },
    heading: {
      name: 'Provide the name of agency/organization/individual to which debt is/was owed',
      infractions: 'Did/does this financial issue include any of the following:',
      accountnumber: 'Provide the associated loan / account number(s) involved',
      propertytype: 'Identify/describe the type of property involved (if any)',
      amount: 'Provide the amount (in U.S. dollars) of the financial issue',
      reason: 'Provide the reason(s) for the financial issue',
      status: 'Provide the current status of the financial issue',
      date: 'Provide the date the financial issue began',
      resolved: 'Provide the date the financial issue was resolved',
      description:
        'Provide a description of any action(s) you have taken to satisfy this debt (such as withholdings, frequency and amount of payments, etc.). If you have not taken any provide explanation.',
      accountNumberExplanation: 'Provide the explanation for account number',
    },
    label: {
      idk: "I don't know",
      notresolved: 'Not resolved',
      estimated: 'Estimated',
    },
    help: {
      branch: {
        title: 'Need help with nonpayment consequences?',
        message: 'If you have had in of the listed items happen to you then select "Yes"',
        note: '',
      },
      name: {
        title: 'Need help with the name of the agency, organization, or individual?',
        message: 'Provide the name of the agency, organization, or individual',
        note: '',
      },
      infractions: {
        title: 'Need help with types of financial issues?',
        message: 'Select all of the financial issues which applies to this issue',
        note: '',
      },
      accountnumber: {
        title: 'Need help with the associated loan or account number(s)?',
        message: 'Provide the associated loan or account number(s)',
        note: '',
      },
      propertytype: {
        title: 'Need help with the type of property?',
        message: 'Provide a description of the type of property involved, if any',
        note: '',
      },
      amount: {
        title: 'Need help with the financial issue amount?',
        message: 'Provide the approximate amount of the financial issue',
        note: '',
      },
      reason: {
        title: 'Full explanation of this issue',
        message: 'Go into as much detail as you need to fully explain.',
        note: '',
      },
      status: {
        title: 'Need help with the current status?',
        message: 'Provide a description of the current status of the financial issue',
        note: '',
      },
      date: {
        title: 'Need help with the beginning date?',
        message: 'Provide the approximate date the financial issue began',
        note: '',
      },
      resolved: {
        title: 'Need help with the resolved date?',
        message: 'Provide the approximate date, if available, the financial issue was resolved',
        note: '',
      },
      description: {
        title: 'Have you started trying to fix this problem?',
        message:
          "Explain what you have done to fix this problem. If you haven't started yet tell us why.",
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of non-payment issues',
        unknown: 'Provide your non-payment details below',
        item: 'Service',
      },
      appendTitle:
        'Other than previously listed, are there any other instances of the following occurrences?',
      append: 'Add another non-payment or excessive late payment',
    },
  },
};
